import { Injectable, inject } from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../environment/environment";
import {map} from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import {GamePlay} from "../model/game-play";

@Injectable({
  providedIn: 'root'
})
export class GamePlayService {
  private http = inject(HttpClient);


  public loadGamePlay(gameId: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/game/${gameId}/play-by-play`).pipe(
      map(response => {
        return response
      })
    );
  }

  public insertNewPlayByPlay(gameId: string, playByPlay: GamePlay, gamePlayNumber: number): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/game/${gameId}/play-by-play/insert-new-play-by-play`, {
      playByPlay,
      gamePlayNumber
    });
  }

  public updatePlayByPlay(gameId: string, gamePlayId: number, playByPlay: GamePlay): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/game/${gameId}/play-by-play/${gamePlayId}`, {playByPlay});
  }
}
